import { render, staticRenderFns } from "./LinkToDetail.vue?vue&type=template&id=53ed26a1&scoped=true&"
import script from "./LinkToDetail.vue?vue&type=script&lang=js&"
export * from "./LinkToDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed26a1",
  null
  
)

export default component.exports